import { RootState } from "../../../../system/redux/store/community-finder-redux-store";

export const selectShowHotwCard = (state: RootState) =>
	state?.results?.hotw?.show;
